<template>
  <generic-view
    :title="title"
    icon="fax"
    :show_plus="true"
    @add="add"
    :header_buttons="header_buttons"
  >
    <div class="ui icon warning message" v-if="!current_session">
      <i class="triangle exclamation sign icon"></i>
      <div class="content">
        <div class="header">{{ $t("no sales session active") }}</div>
        <p>{{ $t("registered sales won't belong to any session") }}</p>
      </div>
    </div>
    <table
      ref="table"
      class="ui celled selectable striped very compact table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("active") }}</th>
          <th>{{ $t("start date") }}</th>
          <th>{{ $t("closure date") }}</th>
          <th>{{ $t("total") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <template v-for="(mdl, index) in session_modals">
      <component
        :is="mdl"
        :key="index"
        :session_in="selected_session"
        v-on:destroy="destroy"
        v-on:deleted="deleted"
        @show_sale="show_sale"
      ></component>
    </template>
    <template v-for="(mdl, index) in sale_modals">
      <component
        :is="mdl"
        :key="index"
        :sale_uuid="selected_sale_uuid"
        v-on:destroy="destroy"
      ></component>
    </template>
  </generic-view>
</template>

<script>
import { local_api, enterprise_setup, error_toast } from "@/utils";
import SessionModal from "./PointOfSaleSessionModal";
import SaleModal from "../sale_modal/SaleModal";
import GenericView from "@/components/GenericContainer";
import filters from "@/filters";
import "datatables.net";
import "datatables.net-se";
import moment from "moment";

export default {
  filters: filters,
  name: "PointOfSaleSessionPlugin",
  props: {},
  components: {
    "generic-view": GenericView,
  },
  computed: {
    title() {
      if (this.current_session) {
        let ent_setup = enterprise_setup(this);
        return (
          this.$t("sale sessions") +
          " [" +
          this.$t("active since") +
          " " +
          filters.formatDate(
            this.current_session.create_date,
            ent_setup.detailed_date_format,
          ) +
          "]"
        );
      } else return this.$t("sale sessions");
    },
    header_buttons() {
      let _h = [
        {
          icon: "green refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ];
      // if (this.current_session)
      _h.push({
        icon: "store slash red",
        tooltip: this.$t("sales closure"),
        click: this.sales_closure,
      });
      return _h;
    },
  },
  data() {
    return {
      processing: false,
      sessions: [],
      current_session: undefined,
      table: undefined,
      session_modals: [],
      sale_modals: [],
      selected_session: undefined,
      selected_sale_uuid: undefined,
    };
  },
  methods: {
    add() {
      let vm = this;

      if (vm.current_session)
        error_toast(vm.$t("you currently have one session open"));
      else {
        this.$alertify.confirm(
          this.$t("are you sure to create session?"),
          function() {
            local_api(vm, "post", "/point_of_sale/session/do-create", {})
              .then((session) => {
                vm.current_session = session;
                vm.refresh();
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
      }
    },
    refresh() {
      let vm = this;
      let ent_setup = enterprise_setup(this);
      local_api(vm, "post", "/point_of_sale/session/do-get-list", {})
        .then((items) => {
          vm.sessions = items;
          vm.processing = false;

          let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
          if (vm.$i18n.locale == "es")
            dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
          else if (vm.$i18n.locale == "fr")
            dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

          if (vm.table) {
            vm.table.destroy();
          }

          vm.table = window.jQuery(vm.$refs.table).DataTable({
            processing: true,
            order: [[1, "desc"]],
            data: vm.sessions,
            language: {
              url: dict,
            },
            columns: [
              {
                data: function(row) {
                  if (row.status_code == "A")
                    return '<i class="icon checkmark"></i>';
                  else return "";
                },
              },
              {
                type: "date-gt",
                data: function(row) {
                  // console.log(row);
                  return filters.formatDate(
                    row.create_date,
                    ent_setup.detailed_date_format,
                  );
                },
              },
              {
                data: function(row) {
                  if (row.closure_date)
                    return filters.formatDate(
                      row.closure_date,
                      ent_setup.detailed_date_format,
                    );
                  else return "";
                },
              },
              {
                data: function(row) {
                  let total = vm.calculate_total(row);
                  return filters.formatCurrency(total, ent_setup.currency_iso);
                },
              },
            ],
            createdRow: function(row, data) {
              window.jQuery(row).click(function() {
                vm.show_session(data);
              });
              if (data.status_code == "A") {
                window.jQuery(row).addClass("positive");
              }
            },
          });

          let curr = items.find((n) => n.status_code == "A");
          if (curr) vm.current_session = curr;
        })
        .catch((err) => {
          error_toast(err);
          console.error(err);
        });
    },
    calculate_total(session) {
      let total = 0;
      total = session.pos_sales.reduce(function(prev, curr) {
        return prev + Number(curr.total);
      }, 0);
      return total;
    },
    show_session(session) {
      let vm = this;
      vm.selected_session = session;
      vm.session_modals.push(SessionModal);
    },
    sales_closure() {
      let vm = this;
      if (vm.current_session) {
        this.$alertify.prompt(this.$t("sale closure comment"), "", function(
          e,
          comment,
        ) {
          local_api(vm, "post", "/point_of_sale/session/do-closure", {
            i: vm.current_session.uuid,
            c: comment,
          })
            .then(() => {
              vm.current_session = undefined;
              vm.refresh();
            })
            .catch((err) => {
              error_toast(err);
            });
        });
      } else {
        error_toast(vm.$t("no active session found"));
      }
    },
    destroy() {
      this.session_modals = [];
      this.selected_session = undefined;
    },
    show_sale(sale) {
      this.sale_modals.push(SaleModal);
      this.selected_sale_uuid = sale.uuid;
    },
    deleted() {
      window.jQuery(".ui.modal").modal("hide");
      /*this.session_modals = [];
      this.processing = true;*/
      this.refresh();
    },
    // succedded(item) {
    //   let trgtIdx = this.relationships.findIndex(n => n.uuid == item.uuid);
    //   if (trgtIdx != -1) this.relationships.splice(trgtIdx, 1, item);
    //   else this.relationships.push(item);
    // },
    // eslint-disable-next-line no-unused-vars
    // view(item, index) {
    //   this.selected_relationship = item;
    //   // this.popup_modals.push(PetCustomerRelationshipModal);
    // },
    // go_to_pet(relationship) {
    //   this.$router.push({
    //     name: "PetView",
    //     query: { i: relationship.pet_pet.uuid }
    //   });
    // }
  },
  mounted() {
    // let vm = this;
    this.processing = true;
    this.refresh();
    // setTimeout(function() {
    //   local_api(vm, "post", "/point_of_sale/session/do-get-list", {})
    //     .then(items => {
    //       vm.sessions = items;
    //       vm.processing = false;

    //       vm.refresh();

    //       let curr = items.find(n => n.status_code == "A");
    //       if (curr) vm.current_session = curr;
    //     })
    //     .catch(err => {
    //       vm.$alertify.error(err);
    //       console.error(err);
    //     });
    // }, 100);
  },
  watch: {
    current_session() {
      this.$emit("session_updated", this.current_session);
    },
  },
  created() {
    let vm = this;
    let ent_setup = enterprise_setup(vm);
    window.jQuery.extend(window.jQuery.fn.dataTableExt.oSort, {
      "date-gt-pre": function(a) {
        var f = moment(a, ent_setup.detailed_date_format);
        return f;
      },

      "date-gt-asc": function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
      },

      "date-gt-desc": function(a, b) {
        return a < b ? 1 : a > b ? -1 : 0;
      },
    });
  },
};
</script>
